<template>
  <div>
    <div class="searchBox_top" style="">
      <el-button class="btn" size="mini" @click="goBack">返回</el-button>
      <el-button v-if="isSupplier && (recordForm.status === 'SUBMITTED'||recordForm.status === 'OBSOLETED') && !editable" v-acl="PROC_LOT_RECORD_ADD" class="btn" size="mini" type="primary" @click="doEdit">编辑</el-button>
      <el-button v-if="isSupplier && recordForm.status === 'DRAFT'" v-acl="PROC_LOT_RECORD_ADD" class="btn" size="mini" type="primary" @click="doSave">保存并计算</el-button>
      <el-button v-if="isSupplier && (recordForm.status === 'DRAFT' || ((recordForm.status === 'SUBMITTED'||recordForm.status === 'OBSOLETED') && editable))" v-acl="PROC_LOT_RECORD_ADD" class="btn" size="mini" type="primary" @click="doSubmit">提交</el-button>
      <!--      <el-button v-if="recordForm.status === 'SUBMITTED'" class="btn" size="mini" type="primary" @click="doExport">导出</el-button>-->
    </div>
    <el-card class="process__record__card">
      <div slot="header" class="clearfix">
        <div class="title">
          <span class="line"></span>
          <span>基本信息</span>
        </div>
      </div>
      <el-form :model="recordForm" ref="recordFormRef" :rules="baseRules" label-width="120px">
        <el-row>
          <el-col :span="6">
            <el-form-item label="生产日期" prop="parentBatchNo">
              <template slot="label">
                <span class="mandatory">生产日期</span>
              </template>
              <el-date-picker style="width: 100%;" value-format="yyyy-MM-dd" v-model="recordForm.parentBatchNo" type="date" :placeholder="$t('common.selDate')" :disabled="!editable || recordForm.status === 'SUBMITTED'"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col v-if="recordForm.keyConfig!=='GRIASL'" :span="6">
            <el-form-item label="小批次号" prop="subBatchNo">
              <template slot="label">
                <span class="mandatory">小批次号</span>
              </template>
              <el-input v-model="recordForm.subBatchNo" clearable maxlength="20" :disabled="!editable || recordForm.status === 'SUBMITTED'"></el-input>
            </el-form-item>
          </el-col>
          <el-col v-if="recordForm.keyConfig==='GRIASL'" :span="6">
            <el-form-item label="ASL" prop="aslName">
              <template slot="label">
                <span class="mandatory">ASL</span>
              </template>
              <el-input style="width: 100%;" v-model="recordForm.aslName" :disabled="!editable || recordForm.status === 'SUBMITTED'">
                <el-button v-if="editable && recordForm.status !== 'SUBMITTED'" slot="append" icon="el-icon-search" @click="selectAsl(null, null, 'BASE')"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="工厂" prop="plantName">
              <template slot="label">
                <span class="mandatory">工厂</span>
              </template>
              <el-input style="width: 100%;" v-model="recordForm.plantName" clearable readonly :disabled="!editable || recordForm.status === 'SUBMITTED'">
                <el-button v-if="editable && recordForm.status === 'DRAFT'" slot="append" icon="el-icon-search" @click="showPlanDialog = true"></el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="版本号" prop="version">
              <el-input v-model="recordForm.version" clearable maxlength="50" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="comments">
              <el-input v-model="recordForm.comments" type="textarea" rows="2" maxlength="500" :disabled="!editable"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="GRI编码" prop="griCode">
              <el-input v-model="recordForm.griCode" clearable maxlength="50" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="GRI名称" prop="griName">
              <el-input v-model="recordForm.griName" clearable maxlength="50" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Category2" prop="category2">
              <el-input v-model="recordForm.category2Name" clearable maxlength="50" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="供应商" prop="supplierName">
              <el-input v-model="recordForm.supplierName" clearable maxlength="50" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="制成总数" prop="processNumber">
              <el-input v-model="recordForm.processNumber" clearable maxlength="50" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="状态" prop="statusI18n">
              <el-input v-model="recordForm.statusI18n" clearable maxlength="50" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="Category3" prop="category3">
              <el-input v-model="recordForm.category3Name" clearable maxlength="50" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="6">
            <el-form-item label="创建时间" prop="createDate">
              <el-input v-model="recordForm.createDate" clearable maxlength="50" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="创建人" prop="createUserName">
              <el-input v-model="recordForm.createUserName" clearable maxlength="50" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="更新时间" prop="updateDate">
              <el-input v-model="recordForm.updateDate" clearable maxlength="50" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="更新人" prop="updateUserName">
              <el-input v-model="recordForm.updateUserName" clearable maxlength="50" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-card class="process__record__card process__body">
      <div slot="header" class="clearfix">
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <div class="title">
            <span class="line"></span>
            <span>制成汇总</span>
          </div>
        </div>
      </div>
      <div style="display: flex;min-height: 400px;">
        <div style="width: 350px;border-right: 1px solid #EEEEEE;">
          <div style="padding-top: 10px;overflow-y: auto;">
            <template v-for="(item, index) in recordForm.processes">
              <div v-if="item.display !== 'none'" class="process__item" :class="{'selected':item.tplProcessId === selectedProcess.tplProcessId}" @click="doSelectProcess(item)">
                <div style="display: flex;justify-content: space-between;align-items: center;">
                  <div style="display: flex;align-items: baseline;">
                    <div class="circle__default">{{index + 1}}</div>
                    <div style="margin-left: 15px;font-size: 14px;">{{item.processName}}</div>
                  </div>
                  <div class="circle__small">{{item.factors.length}}</div>
                </div>
              </div>
            </template>
          </div>
          <!--          <div style="border-top: 1px solid #EEEEEE">
            <div style="display: flex;justify-content: space-between;">
              <div>已完成</div>
              <div>0/8</div>
            </div>
          </div>-->
        </div>
        <div ref="factorRef" style="width: calc(100% - 350px);overflow-y: auto;">
          <el-form class="factor__form" :model="recordForm" ref="factorFormRef">
            <div style="margin: 15px;border-radius: 5px;" v-for="factor in factorList">
              <!------------------------------------------- 表单形式 ------------------------------------------------->
              <el-card v-if="factor.inputMode === 'SINGLE'" class="process__record__card factor__card">
                <div slot="header" class="clearfix">
                  <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div class="title">
                      <span class="line"></span>
                      <div v-if="factor.factorCode === 'FAC_0063'">
                        <span>{{factor.factorName}}&nbsp;</span>
                        <span style="font-weight:normal">(请先完成当前生产日期所有小批次号的维护，再统一维护品评报告)</span>
                      </div>
                      <span v-else>{{factor.factorName}}</span>
                    </div>
                    <el-button v-if="factor.factorCode === 'FAC_0063'&&sensoryReportStatus=='DRAFT'&&sensoryReportId" type="primary" @click="goToSensory('edit')">维护品评报告</el-button>
                  </div>
                </div>
                <div style="padding: 10px;">
                  <el-row v-for="(row, rIndex) in groupedParams(factor.params,factor)" :key="rIndex" :gutter="20">
                    <!-- 如果有换行标识则通过css实现换行 -->
                    <el-col v-if="isSupplier?param.supplierViewable:true" :span="6" v-for="(param, index) in row">
                      <!-- supplierViewable - 供应商是否可见 -->
                      <el-form-item class="single__" :label="`${param.paramName}${param.standard?`(${param.standard})`:''}${param.uom?`/${param.uom}`:''}`" :prop="`${param.tplParamId}`">
                        <template slot="label">
                          <span :class="{'mandatory':param.required}">
                            <span>{{param.paramName}}</span>
                            <span v-if="param.standard && param.standardType != 'SINGLE'">(</span>
                            <span v-if="param.standardType != 'SINGLE'">{{param.standard?param.standard:''}}</span>
                            <span v-if="param.standard && param.standardType != 'SINGLE'">)</span>
                            <span v-if="param.uom">/</span>
                            <span>{{param.uom?param.uom:''}}</span>
                          </span>
                          <el-tooltip v-if="param.paramDesc" effect="dark" :content="param.paramDesc" placement="top" popper-class="prod__record">
                            <i class="el-icon-info param__tip"></i>
                          </el-tooltip>
                        </template>
                        <el-input style="width: 100%;" :class="{'invalid__': checkStandardValue(param, param[param.tplParamId], 'SINGLE')}" v-if="param.dataType === 'TEXT' && (isSupplier?param.supplierViewable:true)" v-model="param[param.tplParamId]" :disabled="param.paramType === 'STATISTIC' || !editable" @input="handleProcessVisible(param, param.tplParamId, 'SINGLE')"></el-input>
                        <el-date-picker v-if="param.dataType === 'DATE' && (isSupplier?param.supplierViewable:true)" value-format="yyyy-MM-dd" v-model="param[param.tplParamId]" type="date" :placeholder="$t('common.selDate')" style="width: 100%;" :disabled="param.paramType === 'STATISTIC' || !editable"></el-date-picker>
                        <el-input style="width: 100%;" :class="{'invalid__': checkStandardValue(param, param[param.tplParamId], 'SINGLE')}" v-if="param.dataType === 'NUMBER' && (isSupplier?param.supplierViewable:true)" v-model="param[param.tplParamId]" @input="handleInput(param, param.tplParamId, 'SINGLE')" @blur="calcSpecialParamRequired(param, param[param.tplParamId], 85)" :disabled="param.paramType === 'STATISTIC' || !editable"></el-input>
                        <el-select style="width: 100%;" v-if="param.dataType === 'BOOLEAN' && (isSupplier?param.supplierViewable:true)" v-model="param[param.tplParamId]" :disabled="param.paramType === 'STATISTIC' || !editable">
                          <el-option label="Y" value="1"></el-option>
                          <el-option label="N" value="0"></el-option>
                        </el-select>
                        <el-input style="width: 100%;" v-if="param.dataType === 'SELECTOR'" v-model="param[param.tplParamId]" :disabled="param.paramType === 'STATISTIC' || !editable" :readonly="param.selectorType === 'ASL'">
                          <el-button v-if="param.selectorType === 'ASL' && editable" slot="append" icon="el-icon-search" @click="selectAsl(param, param.tplParamId, 'SINGLE')"></el-button>
                        </el-input>
                        <ic-select v-if="param.dataType === 'DICT'" :table="param.dictTable" :field="param.dictField" clearable v-model="param[param.tplParamId]" style="width:100%" :disabled="param.paramType === 'STATISTIC' || !editable"></ic-select>
                        <el-button style="width: 100%;text-align:left" type="text" v-if="param.dataType=='sensoryReportNo'" @click="goToSensory('view')">{{sensoryReportNo}}</el-button>
                      </el-form-item>
                    </el-col>
                    <!-- <el-col>
                      <el-form-item>
                        <el-button type="text" v-if="factor.factorCode === 'FAC_0063'" @click="goToSensory">{{sensoryReportNo}}</el-button>
                      </el-form-item>
                    </el-col> -->
                  </el-row>
                </div>
              </el-card>

              <!-------------------------------------------------- 列表形式 ------------------------------------------->
              <el-card v-if="factor.inputMode === 'LIST'" class="process__record__card factor__card">
                <div slot="header" class="clearfix">
                  <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div class="title">
                      <span class="line"></span>
                      <span>{{factor.factorName}}</span>
                    </div>
                    <el-button v-if="editable" type="primary" size="mini" @click="addParam(factor)">新增行</el-button>
                  </div>
                </div>
                <div style="margin: 10px;">
                  <el-table style="width: 100%" :data="factor.dataList" border>
                    <template v-if="groupedColumns(factor).length == 1 && !hasEmptyCategory(factor)">
                      <el-table-column v-if="isSupplier?column.supplierViewable:true" v-for="column in factor.params" :key="column.tplParamId" :prop="column.tplParamId" :label="column.paramName" :min-width="calcMinWidth(column.paramName, column.standard, column.uom)">
                        <template slot="header" slot-scope="scope">
                          <span :class="{'mandatory':column.required}">
                            <span>{{column.paramName}}</span>
                            <span v-if="column.standard && column.standardType != 'SINGLE'">(</span>
                            <span v-if="column.standardType != 'SINGLE'">{{column.standard?column.standard:''}}</span>
                            <span v-if="column.standard && column.standardType != 'SINGLE'">)</span>
                            <span v-if="column.uom">/</span>
                            <span>{{column.uom?column.uom:''}}</span>
                          </span>
                          <el-tooltip v-if="column.paramDesc" effect="dark" :content="column.paramDesc" placement="top" popper-class="prod__record">
                            <i class="el-icon-info param__tip"></i>
                          </el-tooltip>
                        </template>
                        <template slot-scope="scope">
                          <el-form-item>
                            <el-input :class="{'invalid__': checkStandardValue(scope.row.dataMap[column.tplParamId], scope.row.dataMap[column.tplParamId].paramValue, 'LIST')}" v-if="column.dataType === 'TEXT'" v-model="scope.row.dataMap[column.tplParamId].paramValue" :disabled="column.paramType === 'STATISTIC' || !editable"></el-input>
                            <el-date-picker v-if="column.dataType === 'DATE'" style="width: 100%;" type="date" value-format="yyyy-MM-dd" v-model="scope.row.dataMap[column.tplParamId].paramValue" :placeholder="$t('common.selDate')" :disabled="column.paramType === 'STATISTIC' || !editable"></el-date-picker>
                            <el-input :class="{'invalid__': checkStandardValue(scope.row.dataMap[column.tplParamId], scope.row.dataMap[column.tplParamId].paramValue, 'LIST')}" v-if="column.dataType === 'NUMBER'" v-model="scope.row.dataMap[column.tplParamId].paramValue" @input="handleInput(scope.row.dataMap, column.tplParamId, 'LIST')" @blur="calcSpecialParamRequiredList(scope.row.dataMap, column.tplParamId, 85)" :disabled="column.paramType === 'STATISTIC' || !editable"></el-input>
                            <el-select v-if="column.dataType === 'BOOLEAN'" v-model="scope.row.dataMap[column.tplParamId].paramValue" :disabled="column.paramType === 'STATISTIC' || !editable">
                              <el-option label="Y" value="1"></el-option>
                              <el-option label="N" value="0"></el-option>
                            </el-select>
                            <el-input v-if="column.dataType === 'SELECTOR'" v-model="scope.row.dataMap[column.tplParamId].paramValue" :disabled="column.paramType === 'STATISTIC' || !editable" :readonly="column.selectorType === 'ASL'">
                              <el-button v-if="column.selectorType === 'ASL' && editable" slot="append" icon="el-icon-search" @click="selectAsl(scope.row.dataMap[column.tplParamId], null, 'LIST')"></el-button>
                            </el-input>
                            <ic-select v-if="column.dataType === 'DICT'" :table="column.dictTable" :field="column.dictField" clearable v-model="scope.row.dataMap[column.tplParamId].paramValue" style="width:100%" :disabled="column.paramType === 'STATISTIC' || !editable"></ic-select>
                          </el-form-item>
                        </template>
                      </el-table-column>
                    </template>
                    <!-- 需要合并表头的情况 -->
                    <template v-else>
                      <template v-for="(categoryGroup, categoryIndex) in groupedColumns(factor)">
                        <el-table-column v-if="categoryGroup.category" :key="'category-'+categoryIndex+'-'+factor.factorId" :label="categoryGroup.category">
                          <el-table-column v-if="isSupplier?column.supplierViewable:true" v-for="column in categoryGroup.columns" :key="column.tplParamId" :prop="column.tplParamId" :label="column.paramName" :min-width="calcMinWidth(column.paramName, column.standard, column.uom)">
                            <template slot="header" slot-scope="scope">
                              <span :class="{'mandatory':column.required}">
                                <span>{{column.paramName}}</span>
                                <span v-if="column.standard && column.standardType != 'SINGLE'">(</span>
                                <span v-if="column.standardType != 'SINGLE'">{{column.standard?column.standard:''}}</span>
                                <span v-if="column.standard && column.standardType != 'SINGLE'">)</span>
                                <span v-if="column.uom">/</span>
                                <span>{{column.uom?column.uom:''}}</span>
                              </span>
                              <el-tooltip v-if="column.paramDesc" effect="dark" :content="column.paramDesc" placement="top" popper-class="prod__record">
                                <i class="el-icon-info param__tip"></i>
                              </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                              <el-form-item>
                                <el-input :class="{'invalid__': checkStandardValue(scope.row.dataMap[column.tplParamId], scope.row.dataMap[column.tplParamId].paramValue, 'LIST')}" v-if="column.dataType === 'TEXT'" v-model="scope.row.dataMap[column.tplParamId].paramValue" :disabled="column.paramType === 'STATISTIC' || !editable"></el-input>
                                <el-date-picker v-if="column.dataType === 'DATE'" style="width: 100%;" type="date" value-format="yyyy-MM-dd" v-model="scope.row.dataMap[column.tplParamId].paramValue" :placeholder="$t('common.selDate')" :disabled="column.paramType === 'STATISTIC' || !editable"></el-date-picker>
                                <el-input :class="{'invalid__': checkStandardValue(scope.row.dataMap[column.tplParamId], scope.row.dataMap[column.tplParamId].paramValue, 'LIST')}" v-if="column.dataType === 'NUMBER'" v-model="scope.row.dataMap[column.tplParamId].paramValue" @input="handleInput(scope.row.dataMap, column.tplParamId, 'LIST')" @blur="calcSpecialParamRequiredList(scope.row.dataMap, column.tplParamId, 85)" :disabled="column.paramType === 'STATISTIC' || !editable"></el-input>
                                <el-select v-if="column.dataType === 'BOOLEAN'" v-model="scope.row.dataMap[column.tplParamId].paramValue" :disabled="column.paramType === 'STATISTIC' || !editable">
                                  <el-option label="Y" value="1"></el-option>
                                  <el-option label="N" value="0"></el-option>
                                </el-select>
                                <el-input v-if="column.dataType === 'SELECTOR'" v-model="scope.row.dataMap[column.tplParamId].paramValue" :disabled="column.paramType === 'STATISTIC' || !editable" :readonly="column.selectorType === 'ASL'">
                                  <el-button v-if="column.selectorType === 'ASL' && editable" slot="append" icon="el-icon-search" @click="selectAsl(scope.row.dataMap[column.tplParamId], null, 'LIST')"></el-button>
                                </el-input>
                                <ic-select v-if="column.dataType === 'DICT'" :table="column.dictTable" :field="column.dictField" clearable v-model="scope.row.dataMap[column.tplParamId].paramValue" style="width:100%" :disabled="column.paramType === 'STATISTIC' || !editable"></ic-select>
                              </el-form-item>
                            </template>
                          </el-table-column>
                        </el-table-column>

                        <template v-else>
                          <el-table-column v-for="(column, colIndex) in categoryGroup.columns" :key="column.tplParamId+'-'+colIndex" :prop="column.tplParamId" :label="column.paramName" :min-width="calcMinWidth(column.paramName, column.standard, column.uom)" v-if="isSupplier?column.supplierViewable:true">
                            <template slot="header" slot-scope="scope">
                              <span :class="{'mandatory':column.required}">
                                <span>{{column.paramName}}</span>
                                <span v-if="column.standard && column.standardType != 'SINGLE'">(</span>
                                <span v-if="column.standardType != 'SINGLE'">{{column.standard?column.standard:''}}</span>
                                <span v-if="column.standard && column.standardType != 'SINGLE'">)</span>
                                <span v-if="column.uom">/</span>
                                <span>{{column.uom?column.uom:''}}</span>
                              </span>
                              <el-tooltip v-if="column.paramDesc" effect="dark" :content="column.paramDesc" placement="top" popper-class="prod__record">
                                <i class="el-icon-info param__tip"></i>
                              </el-tooltip>
                            </template>
                            <template slot-scope="scope">
                              <el-form-item>
                                <el-input :class="{'invalid__': checkStandardValue(scope.row.dataMap[column.tplParamId], scope.row.dataMap[column.tplParamId].paramValue, 'LIST')}" v-if="column.dataType === 'TEXT'" v-model="scope.row.dataMap[column.tplParamId].paramValue" :disabled="column.paramType === 'STATISTIC' || !editable"></el-input>
                                <el-date-picker v-if="column.dataType === 'DATE'" style="width: 100%;" type="date" value-format="yyyy-MM-dd" v-model="scope.row.dataMap[column.tplParamId].paramValue" :placeholder="$t('common.selDate')" :disabled="column.paramType === 'STATISTIC' || !editable"></el-date-picker>
                                <el-input :class="{'invalid__': checkStandardValue(scope.row.dataMap[column.tplParamId], scope.row.dataMap[column.tplParamId].paramValue, 'LIST')}" v-if="column.dataType === 'NUMBER'" v-model="scope.row.dataMap[column.tplParamId].paramValue" @input="handleInput(scope.row.dataMap, column.tplParamId, 'LIST')" @blur="calcSpecialParamRequiredList(scope.row.dataMap, column.tplParamId, 85)" :disabled="column.paramType === 'STATISTIC' || !editable"></el-input>
                                <el-select v-if="column.dataType === 'BOOLEAN'" v-model="scope.row.dataMap[column.tplParamId].paramValue" :disabled="column.paramType === 'STATISTIC' || !editable">
                                  <el-option label="Y" value="1"></el-option>
                                  <el-option label="N" value="0"></el-option>
                                </el-select>
                                <el-input v-if="column.dataType === 'SELECTOR'" v-model="scope.row.dataMap[column.tplParamId].paramValue" :disabled="column.paramType === 'STATISTIC' || !editable" :readonly="column.selectorType === 'ASL'">
                                  <el-button v-if="column.selectorType === 'ASL' && editable" slot="append" icon="el-icon-search" @click="selectAsl(scope.row.dataMap[column.tplParamId], null, 'LIST')"></el-button>
                                </el-input>
                                <ic-select v-if="column.dataType === 'DICT'" :table="column.dictTable" :field="column.dictField" clearable v-model="scope.row.dataMap[column.tplParamId].paramValue" style="width:100%" :disabled="column.paramType === 'STATISTIC' || !editable"></ic-select>
                              </el-form-item>
                            </template>
                          </el-table-column>
                        </template>
                      </template>
                    </template>

                    <el-table-column v-if="editable" label="操作" width="80" fixed="right" key="op">
                      <template slot-scope="scope">
                        <i class="el-icon-delete" style="color: red;cursor: pointer;" @click="deleteParam(factor, scope.$index)"></i>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-card>

              <!------------------------------------ 二维表格 自定义列&自定义行 ---------------------------------------->
              <el-card v-if="factor.inputMode === 'TABLE'" class="process__record__card factor__card">
                <div slot="header" class="clearfix">
                  <div style="display: flex;justify-content: space-between;">
                    <div class="title">
                      <span class="line"></span>
                      <span>{{factor.factorName}}</span>
                    </div>
                  </div>
                </div>
                <div>
                  <el-table style="width: 100%" :data="factor.dataList" border>
                    <el-table-column prop="paramName" label="参数" min-width="150" key="pn">
                      <template slot-scope="scope">
                        <span>{{scope.row.paramName}}</span>
                        <span v-if="scope.row.standard && scope.row.standardType != 'SINGLE'">(</span>
                        <span v-if="scope.row.standardType != 'SINGLE'">{{scope.row.standard?scope.row.standard:''}}</span>
                        <span v-if="scope.row.standard && scope.row.standardType != 'SINGLE'">)</span>
                        <span v-if="scope.row.uom">/</span>
                        <span>{{scope.row.uom?scope.row.uom:''}}</span>
                        <el-tooltip v-if="scope.row.paramDesc" effect="dark" :content="scope.row.paramDesc" placement="top" popper-class="prod__record">
                          <i class="el-icon-info param__tip"></i>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                    <el-table-column v-for="(column, index) in factor.columns" :key="index" :label="column.columnName" min-width="140">
                      <template slot="header" slot-scope="scope">
                        {{column.columnName}}
                        <el-tooltip v-if="column.columnDesc" effect="dark" :content="column.columnDesc" placement="top" popper-class="prod__record">
                          <i class="el-icon-info param__tip"></i>
                        </el-tooltip>
                      </template>
                      <template slot-scope="scope">
                        <el-form-item>
                          <el-input :class="{'invalid__': checkStandardValue(scope.row, scope.row.dataMap[column.tplColumnId], 'TABLE')}" v-if="scope.row.dataType === 'TEXT'" v-model="scope.row.dataMap[column.tplColumnId]" :disabled="scope.row.paramType === 'STATISTIC' || !editable"></el-input>
                          <el-date-picker v-if="scope.row.dataType === 'DATE'" style="width: 100%;" v-model="scope.row.dataMap[column.tplColumnId]" type="date" value-format="yyyy-MM-dd" :placeholder="$t('common.selDate')" :disabled="scope.row.paramType === 'STATISTIC' || !editable"></el-date-picker>
                          <el-input :class="{'invalid__': checkStandardValue(scope.row, scope.row.dataMap[column.tplColumnId], 'TABLE')}" v-if="scope.row.dataType === 'NUMBER'" v-model="scope.row.dataMap[column.tplColumnId]" @input="handleInput(scope.row.dataMap, column.tplColumnId, 'TABLE')" :disabled="scope.row.paramType === 'STATISTIC' || !editable"></el-input>
                          <el-select v-if="scope.row.dataType === 'BOOLEAN'" v-model="scope.row.dataMap[column.tplColumnId]" :disabled="scope.row.paramType === 'STATISTIC' || !editable">
                            <el-option label="Y" value="1"></el-option>
                            <el-option label="N" value="0"></el-option>
                          </el-select>
                          <el-input v-if="scope.row.dataType === 'SELECTOR'" v-model="scope.row.dataMap[column.tplColumnId]" :disabled="scope.row.paramType === 'STATISTIC' || !editable" :readonly="scope.row.selectorType === 'ASL'">
                            <el-button v-if="scope.row.selectorType === 'ASL' && editable" slot="append" icon="el-icon-search" @click="selectAsl(scope.row.dataMap, column.tplColumnId, 'TABLE')"></el-button>
                          </el-input>
                          <ic-select v-if="scope.row.dataType === 'DICT'" :table="scope.row.dictTable" :field="scope.row.dictField" clearable v-model="scope.row.dataMap[column.tplColumnId]" style="width:100%" :disabled="scope.row.paramType === 'STATISTIC' || !editable"></ic-select>
                        </el-form-item>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </el-card>
            </div>
          </el-form>
        </div>
      </div>
    </el-card>

    <el-card class="process__record__card">
      <div slot="header" class="clearfix">
        <div class="title">
          <span class="line"></span>
          <span>操作日志</span>
        </div>
      </div>
      <el-table style="width: 100%;" :data="logList" border>
        <el-table-column prop="createDate" label="操作时间" min-width="120"></el-table-column>
        <el-table-column prop="operatorCode" label="用户编码" min-width="120"></el-table-column>
        <el-table-column prop="operatorName" label="用户名称" min-width="120"></el-table-column>
        <el-table-column prop="action" label="操作" min-width="120"></el-table-column>
        <el-table-column prop="comments" label="变更原因" min-width="120"></el-table-column>
      </el-table>
    </el-card>

    <el-dialog title="填写变更原因" :visible.sync="dialogVisible" width="50" :close-on-click-modal="false">
      <el-form :model="updateReasonForm" ref="updateReasonFormRef" :rules="reasonRules" label-width="100px">
        <el-form-item required label="变更原因" prop="updateReason">
          <el-input style="width: 100%;" type="textarea" maxlength="500" v-model="updateReasonForm.updateReason" rows="4"></el-input>
        </el-form-item>
      </el-form>
      <div style="display: flex;justify-content: flex-end;">
        <el-button class="btn" size="mini" @click="dialogVisible = false">取消</el-button>
        <el-button class="btn" size="mini" type="primary" @click="confirmSubmitWithReason">确认提交</el-button>
      </div>
    </el-dialog>

    <plantDialog :is-show.sync="showPlanDialog" :scoped="true" :create-fun="onConfirmPlan" @hideDialog="showPlanDialog = false" />
    <aslDialog :is-show.sync="showAslDialog" :create-fun="onConfirmAsl" @hideDialog="showAslDialog = false" />
  </div>
</template>

<script>

import _ from "lodash";
import commonFun from "@/utils/commonFun";
import ppmApi from "@/api/productionProcessMonitoring/index";
import plantDialog from "@/components/page/processMonitoring/dialog/plant-dialog.vue";
import aslDialog from "@/components/page/processMonitoring/dialog/asl-dialog.vue";
import IcSelect from "@/components/common/icSelect.vue";
import Decimal from "decimal.js";

export default {
  components: {
    IcSelect,
    plantDialog,
    aslDialog
  },
  data() {
    return {
      supplierObj: {},
      isSupplier: false,
      showPlanDialog: false,   // 选择工厂弹窗
      showAslDialog: false,    // 选择ASL弹窗
      dialogVisible: false,    // 变更原因弹窗
      recordForm: {
        recordId: "",
        processes: []
      },
      selectedProcess: {},
      factorList: [],
      editable: false,
      logList: [],
      // 变更原因
      updateReasonForm: {
        updateReason: ""
      },
      selectedParam: {},
      selectedKey: "",
      selectedType: "",
      baseRules: {
        parentBatchNo: [
          // {required: true, message: "生产日期不能为空", trigger: "change"}
        ],
        subBatchNo: [
          // {required: true, message: "小批次号不能为空", trigger: ["blur","change"]}
        ],
        plantName: [
          // {required: true, message: "工厂不能为空", trigger: ["blur","change"]}
        ]
      },
      reasonRules: {
        updateReason: [
          { required: true, message: "请填写变更原因", trigger: ["blur", "change"] }
        ]
      },
      sensoryReportNo: "",
      sensoryReportId: "",
      sensoryReportStatus: "",
    }
  },
  created() {
    this.supplierObj = JSON.parse(localStorage.getItem('supplierObj'));
    // if(this.supplierObj) {
    //   this.isSupplier = true;
    // }
    this.isSupplier = commonFun.isSupplier();
    this.doInit();
  },
  mounted() {

  },
  methods: {
    async doInit() {
      await this.getTemplate();
      if (this.$route.query.id) {
        await this.getTemplateDetail();
        this.getOperationLog();
      } else {
        this.editable = true;
      }
      if (this.isSupplier) {
        this.editable = true;
      } else {
        this.editable = false;
      }
    },
    // 获取模板
    async getTemplate() {
      let request = {
        tplId: this.$route.query.tplId
      };
      let res = await ppmApi.getProcessRecordTemplate(request);
      if (res.code == 200) {
        this.recordForm = res.data ? res.data : { processes: [] };
        this.recordForm.status = "DRAFT";
        this.recordForm.comments = "";
        this.recordForm.createDate = "";
        this.recordForm.createUserName = localStorage.getItem("ms_username");
        this.recordForm.updateDate = "";
        this.recordForm.updateBy = "";
        // if(this.supplierObj) {
        //   this.recordForm.supplierCode = this.supplierObj.supplierCode;
        //   this.recordForm.supplierName = this.supplierObj.supplierName;
        // }
        if (this.recordForm && this.recordForm.processes && this.recordForm.processes.length > 0) {
          this.recordForm.processNumber = this.recordForm.processes.length;
          this.selectedProcess = this.recordForm.processes[0];
          if (this.selectedProcess) {
            this.factorList = this.selectedProcess.factors;
          }
          this.recordForm.processes.forEach(process => {
            if (process.factors && process.factors.length > 0) {
              process.factors.forEach(factor => {
                if (!factor.dataList) {
                  factor.dataList = [];
                }
                // 处理二维表格
                if (factor.columns && factor.columns.length > 0) {
                  factor.dataList = [];
                  let data = {};
                  factor.columns.forEach(column => {
                    let columnId = column.tplColumnId;
                    data[columnId] = "";
                  })
                  if (factor.params && factor.params.length > 0) {
                    factor.params.forEach(param => {
                      factor.dataList.push({
                        tplProcessId: process.tplProcessId,
                        tplProcessName: process.processName,
                        tplFactorId: factor.tplFactorId,
                        tplFactorName: factor.factorName,
                        tplFactorInputMode: factor.inputMode,
                        tplParamId: param.tplParamId,
                        tplFactorParamName: param.paramName,
                        paramName: param.paramName,
                        paramDesc: param.paramDesc,
                        paramType: param.paramType,
                        dataType: param.dataType,
                        selectorType: param.selectorType,
                        standard: param.standard,
                        standardType: param.standardType,
                        standardTypeText: param.standardTypeText,
                        uom: param.uom,
                        toleranceType: param.toleranceType,
                        tolerance: param.tolerance,
                        dictTable: param.dataType==="DICT"?param.selectorType.split(":")[0]:"",
                        dictField: param.dataType==="DICT"?param.selectorType.split(":")[1]:"",
                        dataMap: JSON.parse(JSON.stringify(data))
                      });
                    });
                  }
                }
              })
            }
          })
        }
        console.log('123132123123', this.factorList);

      }
    },
    // 选择工厂后获取初始数据
    async getInitData() {
      let request = {
        tplId: this.$route.query.tplId,
        plantCode: this.recordForm.plantCode,
        griCode: this.recordForm.griCode,
      };
      let res = await ppmApi.getProcessInitData(request);
      if (res.code == 200) {
        let data = res.data;
        if (data) {
          this.setTemplateData(data);
        }
      } else {
        this.$message.error(res.msg);
      }
    },
    goToSensory(type) {
      let resolve = this.$router.resolve({
        path: `/processSensoryReport-edit?id=${this.sensoryReportId}&type=${type}`
      });
      window.open(resolve.href, "_blank");
    },
    // 获取模板数据
    async getTemplateDetail() {
      let request = {
        id: this.$route.query.id
      }
      let res = await ppmApi.getProcessRecordTemplateDetail(request);
      if (res.code == 200) {
        let base = res.data.base;
        this.sensoryReportNo = res.data.base.sensoryReportNo;
        this.sensoryReportId = res.data.base.sensoryReportId;
        this.sensoryReportStatus = res.data.base.sensoryReportStatus;
        let processMap = res.data.data;
        Object.keys(base).forEach(k => {
          this.$set(this.recordForm, k, base[k]);
        })
        if (this.recordForm.status === "DRAFT") {
          this.editable = true;
        }
        this.setTemplateData(processMap);
      }
    },
    // 模板数据赋值
    setTemplateData(map) {
      let valueList = [];
      Object.keys(map).forEach(tplProcessId => {
        let process = map[tplProcessId];
        if (process.factors) {
          let factorMap = process.factors;
          Object.keys(factorMap).forEach(tplFactorId => {
            let factor = factorMap[tplFactorId];
            if (factor.params) {
              let paramMap = factor.params;
              Object.keys(paramMap).forEach(tplFactorParamId => {
                let param = paramMap[tplFactorParamId];
                if (param.listDataValue) {
                  let dataValueMap = param.listDataValue;
                  Object.keys(dataValueMap).forEach((k) => {
                    let paramValue = dataValueMap[k];
                    valueList.push({
                      lineNo: k,
                      tplProcessId: process.tplProcessId,
                      tplProcessName: process.processName,
                      tplFactorId: factor.tplFactorId,
                      tplFactorName: factor.factorName,
                      tplFactorParamId: param.tplFactorParamId,
                      tplFactorParamName: param.factorParamName,
                      paramCode: param.factorParamCode,
                      paramValue: paramValue
                    })
                  })
                }
                if (param.singleDataValue) {
                  valueList.push({
                    lineNo: 1,
                    tplProcessId: process.tplProcessId,
                    tplProcessName: process.processName,
                    tplFactorId: factor.tplFactorId,
                    tplFactorName: factor.factorName,
                    tplFactorParamId: param.tplFactorParamId,
                    tplFactorParamName: param.factorParamName,
                    paramCode: param.factorParamCode,
                    paramValue: param.singleDataValue
                  })
                }
                if (param.tableDataValue) {
                  valueList.push({
                    tplProcessId: process.tplProcessId,
                    tplProcessName: process.processName,
                    tplFactorId: factor.tplFactorId,
                    tplFactorName: factor.factorName,
                    tplFactorParamId: param.tplFactorParamId,
                    tplFactorParamName: param.factorParamName,
                    paramCode: param.factorParamCode,
                    dataMap: param.tableDataValue
                  })
                }
              })
            }
          })
        }
      })
      console.log("模板数据列表 ========================================> start")
      console.log(valueList)
      console.log("模板数据列表 <======================================== end")
      this.recordForm.processes.forEach(process => {
        if (process.factors && process.factors.length > 0) {
          let factors = process.factors;
          factors.forEach(factor => {
            if (factor.inputMode === "SINGLE") {
              if (factor.params && factor.params.length > 0) {
                let paramList = factor.params;
                paramList.forEach((param, index) => {
                  // let paramObj = valueList.find(v => v.tplProcessId == process.tplProcessId && v.tplFactorId == factor.tplFactorId && v.tplFactorParamId == param.tplParamId);
                  let paramObj = valueList.find(v => v.paramCode == param.paramCode);
                  if (paramObj) {
                    this.$set(param, param.tplParamId, paramObj.paramValue);
                    if(paramObj.paramValue == 0 && paramObj.paramValue !== "") {
                      this.handleProcessVisible(param, param.tplParamId, '');
                    }
                  }
                })
              }
              if (factor.factorCode === 'FAC_0063' && this.sensoryReportStatus === 'SUBMIT') {
                factor.params.push({
                  lineBreak: false,
                  paramCode: "sensoryReportNo",
                  paramDesc: "",
                  paramName: "品评报告编号",
                  dataType: 'sensoryReportNo',
                  supplierViewable: true
                })
              }
            }
            if (factor.inputMode === "LIST") {
              let paramList = valueList.filter(v => v.tplProcessId == process.tplProcessId && v.tplFactorId == factor.tplFactorId);
              if (paramList.length > 0) {
                let dataList = [];
                let groupData = _.groupBy(paramList, "lineNo");
                Object.keys(groupData).forEach((lineNo, index) => {
                  let itemList = groupData[lineNo];
                  let dataMap = {};
                  factor.params.forEach(param => {
                    let item = itemList.find(o => o.tplFactorParamId === param.tplParamId);
                    if (item) {
                      dataMap[param.tplParamId] = {
                        paramValue: item.paramValue,
                        paramName: param.paramName,
                        paramCode: param.paramCode,
                        paramType: param.paramType,
                        standard: param.standard,
                        standardType: param.standardType,
                        required: param.required,
                        supplierViewable: param.supplierViewable,
                        dataType: param.dataType,
                        processList: param.processList,
                        toleranceType: param.toleranceType,
                        tolerance: param.tolerance
                      }
                    } else {
                      dataMap[param.tplParamId] = {
                        paramValue: "",
                        paramName: param.paramName,
                        paramCode: param.paramCode,
                        paramType: param.paramType,
                        standard: param.standard,
                        standardType: param.standardType,
                        required: param.required,
                        supplierViewable: param.supplierViewable,
                        dataType: param.dataType,
                        processList: param.processList,
                        toleranceType: param.toleranceType,
                        tolerance: param.tolerance
                      }
                    }
                  })
                  dataList.push({
                    tplProcessId: itemList[0].tplProcessId,
                    tplProcessName: itemList[0].processName,
                    tplFactorId: itemList[0].tplFactorId,
                    tplFactorName: factor.factorName,
                    tplFactorInputMode: factor.inputMode,
                    dataMap: dataMap
                  })
                })
                factor.dataList = dataList;
              }
            }
            if (factor.inputMode === "TABLE") {
              if (factor.dataList.length > 0) {
                factor.dataList.forEach(data => {
                  let paramObj = valueList.find(v => v.tplProcessId == process.tplProcessId && v.tplFactorId == factor.tplFactorId && v.tplFactorParamId === data.tplParamId);
                  if (paramObj) {
                    data.dataMap = JSON.parse(JSON.stringify(paramObj.dataMap));
                  }
                })
              }
            }
          })
        }
      })
      console.log("recordFrom ----------------------------------------------------->")
      console.log(this.recordForm)
    },
    // 操作记录
    async getOperationLog() {
      let request = {
        id: this.$route.query.id
      }
      let res = await ppmApi.getOperationLog(request);
      if (res.code == 200) {
        this.logList = res.data.resultData;
      }
    },
    // 编辑
    doEdit() {
      this.editable = true;
    },
    // 导出
    doExport() {

    },
    doSelectProcess(item) {
      this.selectedProcess = item;
      this.factorList = item.factors ? item.factors : [];
      this.$refs.factorRef.scrollTo(0, 0)
    },
    addParam(factor) {
      let data = {};
      factor.params.forEach(param => {
        let tplId = param.tplParamId;
        data[tplId] = {
          paramValue: "",
          paramName: param.paramName,
          paramDesc: param.paramDesc,
          standard: param.standard,
          standardType: param.standardType,
          dataType: param.dataType,
          required: param.required,
          supplierViewable: param.supplierViewable,
          processList: param.processList,
          toleranceType: param.toleranceType,
          tolerance: param.tolerance
        };
      });
      factor.dataList.push({
        tplProcessId: this.selectedProcess.tplProcessId,
        tplProcessName: this.selectedProcess.processName,
        tplFactorId: factor.tplFactorId,
        tplFactorName: factor.factorName,
        tplFactorInputMode: factor.inputMode,
        dataMap: JSON.parse(JSON.stringify(data))
      });
    },
    deleteParam(factor, index) {
      factor.dataList.splice(index, 1);
    },
    // 组装数据
    handleProcessData() {
      let values = [];
      if (this.recordForm.processes.length > 0) {
        this.recordForm.processes.forEach(process => {
          if (process.factors && process.factors.length > 0) {
            process.factors.forEach(factor => {
              if (factor.inputMode === "SINGLE") {
                if (factor.params && factor.params.length > 0) {
                  factor.params.forEach((param, index) => {
                    let tplParamId = param.tplParamId;
                    if (param[tplParamId] && param.paramType != "STATISTIC") {
                      values.push({
                        lineNo: 1,
                        recordId: this.recordForm.recordId ? this.recordForm.recordId : null,
                        tplFactorInputMode: factor.inputMode,
                        tplFactorId: factor.tplFactorId,
                        tplFactorName: factor.factorName,
                        tplColumnId: null,
                        tplFactorParamId: param.tplParamId,
                        tplFactorParamName: param.paramName,
                        tplProcessId: process.tplProcessId,
                        tplProcessName: process.processName,
                        factorAbnormal: param.factorAbnormal,
                        dataValue: param[tplParamId] ? param[tplParamId] : null
                      })
                    }
                  });
                }
              }
              if (factor.inputMode === "LIST") {
                let dataList = factor.dataList;
                if (dataList.length > 0) {
                  dataList.forEach((data, index) => {
                    if (data.dataMap) {
                      let map = data.dataMap
                      Object.keys(map).forEach((k) => {
                        if (map[k].paramValue && map[k].paramType != "STATISTIC") {
                          values.push({
                            lineNo: index + 1,
                            recordId: this.recordForm.recordId ? this.recordForm.recordId : null,
                            tplFactorInputMode: data.tplFactorInputMode,
                            tplFactorId: data.tplFactorId,
                            tplFactorName: data.tplFactorName,
                            tplColumnId: null,
                            tplFactorParamId: k,
                            tplFactorParamName: map[k].paramName,
                            tplProcessId: data.tplProcessId,
                            tplProcessName: data.tplProcessName,
                            factorAbnormal: map[k].factorAbnormal,
                            dataValue: map[k].paramValue
                          })
                        }
                      })
                    }
                  })
                }
              }
              if (factor.inputMode === "TABLE") {
                let dataList = factor.dataList;
                if (dataList.length > 0) {
                  dataList.forEach(data => {
                    if (data.dataMap) {
                      let map = data.dataMap;
                      Object.keys(map).forEach((k, index) => {
                        if (map[k] && data.paramType != "STATISTIC") {
                          values.push({
                            lineNo: 1,
                            recordId: this.recordForm.recordId ? this.recordForm.recordId : null,
                            tplFactorInputMode: data.tplFactorInputMode,
                            tplFactorId: data.tplFactorId,
                            tplFactorName: data.factorName,
                            tplColumnId: k,
                            tplFactorParamId: data.tplParamId,
                            tplFactorParamName: data.paramName,
                            tplProcessId: data.tplProcessId,
                            tplProcessName: data.tplProcessName,
                            factorAbnormal: data.factorAbnormal,
                            dataValue: map[k]
                          })
                        }
                      })
                    }
                  })
                }
              }
            });
          }
        });
      }
      return values
    },
    // 保存
    async doSave() {
      if (!this.recordForm.parentBatchNo || !this.recordForm.plantCode) {
        this.$message.error("基本信息未填写完整");
        return false;
      }
      if(this.recordForm.keyConfig!=='GRIASL'&&!this.recordForm.subBatchNo) {
        this.$message.error("基本信息未填写完整");
        return false;
      }
      if(this.recordForm.keyConfig==='GRIASL'&&!this.recordForm.aslId) {
        this.$message.error("基本信息未填写完整");
        return false;
      }
      let values = this.handleProcessData();
      let errorMsg = this.validParams();
      let request = {
        base: {
          aslId: this.recordForm.aslId,
          comments: this.recordForm.comments,
          writeCompleted: errorMsg ? false : true,
          parentBatchNo: this.recordForm.parentBatchNo,
          plantCode: this.recordForm.plantCode,
          processNumber: this.recordForm.processNumber,
          recordId: this.recordForm.recordId,
          subBatchNo: this.recordForm.subBatchNo,
          supplierCode: this.recordForm.supplierCode,
          tplId: this.$route.query.tplId
        },
        values: values
      };
      let res = await ppmApi.saveProcessRecord(request);
      if (res.meta.code == 200) {
        this.$message.success("保存成功");
        if (!this.recordForm.recordId) {
          this.recordForm.recordId = res.data.recordId;
          this.$router.push({
            path: "/process-monitoring/record/detail",
            query: {
              id: this.recordForm.recordId,
              tplId: this.$route.query.tplId
            }
          })
          this.getTemplateDetail();
        } else {
          this.getTemplateDetail();
        }
      } else {
        this.$message.error(res.meta.msg);
      }
    },
    // 校验表单
    validParams() {
      let errorMsg = "";
      this.recordForm.processes.forEach(process => {
        if (process.display !== "none" && process.factors && process.factors.length > 0) {
          process.factors.forEach(factor => {
            let factorValid = true;
            if (factor.inputMode === "SINGLE") {
              if (factor.params && factor.params.length > 0) {
                factor.params.forEach(param => {
                  if (param.required && param.supplierViewable && !param[param.tplParamId]) {
                    factorValid = false;
                  }
                })
              }
              if (!factorValid) {
                errorMsg = errorMsg.concat("制成【" + process.processName + "】的指标【" + factor.factorName + "】未填写完整").concat("<br/>");
              }
            }
            if (factor.inputMode === "LIST") {
              let required = false;
              // 判断是否有需要必填的参数
              if (factor.params && factor.params.length > 0) {
                factor.params.forEach(param => {
                  if (param.required) {
                    required = true;
                  }
                })
              }
              if (required) {
                // 有必填的参数但是没有填写任何数据则提示
                if (!factor.dataList || (factor.dataList && factor.dataList.length === 0)) {
                  errorMsg = errorMsg.concat("制成【" + process.processName + "】的指标【" + factor.factorName + "】未填写完整").concat("<br/>");
                } else {
                  let valid = true;
                  // 检查每一列的数据是否有未填写的
                  factor.dataList.forEach(data => {
                    if (data.dataMap) {
                      let dataMap = data.dataMap;
                      Object.keys(dataMap).forEach(k => {
                        let data = dataMap[k];
                        if (data.required && data.supplierViewable && !data.paramValue) {
                          valid = false;
                        }
                      })
                    }
                  })
                  if (!valid) {
                    errorMsg = errorMsg.concat("制成【" + process.processName + "】的指标【" + factor.factorName + "】未填写完整").concat("<br/>");
                  }
                }
              }
            }
            if (factor.inputMode === "TABLE") {
              console.log(factor)
              if (factor.dataList && factor.dataList.length > 0) {
                let valid = true;
                let allKeys = new Set();
                factor.dataList.forEach(data => {
                  if (data.dataMap) {
                    let params = data.dataMap;
                    let isNull = Object.values(params).every(
                      value => value === null || value === undefined || value === ""
                    );
                    if (isNull) {
                      valid = false;
                    }
                  }
                })
                // 校验是否某一列的值全部有值，如果列上有一个没值则校验不通过
                if (factor.dataList[0]) {
                  let first = factor.dataList[0];
                  if (first.dataMap) {
                    Object.keys(first.dataMap).forEach(key => allKeys.add(key));
                  }
                  console.log(allKeys)
                  for (const key of allKeys) {
                    const values = factor.dataList.map(item =>
                      item.dataMap ? item.dataMap[key] : undefined
                    );
                    console.log(values)
                    const nonEmptyCount = values.filter(val =>
                      val !== "" && val !== undefined && val !== null
                    ).length;
                    if (nonEmptyCount > 0 && nonEmptyCount < factor.dataList.length) {
                      valid = false;
                    }
                  }
                }
                if (!valid) {
                  errorMsg = errorMsg.concat("制成【" + process.processName + "】的指标【" + factor.factorName + "】未填写完整").concat("<br/>");
                }
              }
            }
          })
        }
      })
      return errorMsg;
    },
    // 提交
    doSubmit() {
      this.updateReasonForm.updateReason = "";
      if (!this.recordForm.parentBatchNo || !this.recordForm.plantCode) {
        this.$message.error("基本信息未填写完整");
        return false;
      }
      if(this.recordForm.keyConfig!=='GRIASL'&&!this.recordForm.subBatchNo) {
        this.$message.error("基本信息未填写完整");
        return false;
      }
      if(this.recordForm.keyConfig==='GRIASL'&&!this.recordForm.aslId) {
        this.$message.error("基本信息未填写完整");
        return false;
      }
      if (this.recordForm.processes && this.recordForm.processes.length > 0) {
        let errorMsg = this.validParams();
        if (errorMsg) {
          this.$message.error({
            message: errorMsg,
            dangerouslyUseHTMLString: true
          });
          return false;
        }
      }
      if (this.recordForm.status === "DRAFT") {
        this.confirmSubmit();
      } else {
        this.dialogVisible = true;
      }
    },
    async confirmSubmitWithReason() {
      this.$refs.updateReasonFormRef.validate(async (valid) => {
        if (valid) {
          await this.confirmSubmit();
        }
      })
    },
    async confirmSubmit() {
      let values = this.handleProcessData();
      let request = {
        base: {
          aslId: this.recordForm.aslId,
          comments: this.recordForm.comments,
          writeCompleted: true,
          parentBatchNo: this.recordForm.parentBatchNo,
          plantCode: this.recordForm.plantCode,
          processNumber: this.recordForm.processNumber,
          recordId: this.recordForm.recordId,
          subBatchNo: this.recordForm.subBatchNo,
          supplierCode: this.recordForm.supplierCode,
          tplId: this.$route.query.tplId,
          updateReason: this.updateReasonForm.updateReason
        },
        values: values
      };
      let res = await ppmApi.submitProcessRecord(request);
      if (res.meta.code == 200) {
        this.$message.success("提交成功");
        this.$router.push({
          path: "/process-monitoring/record"
        })
      } else {
        this.$message.error(res.meta.msg);
      }
    },
    onConfirmPlan(data) {
      this.recordForm.plantCode = data.supplierCode;
      this.recordForm.plantName = data.supplierName;
      this.recordForm.supplierName = data.otherName;
      this.recordForm.supplierCode = data.otherCode;
      this.showPlanDialog = false;
      if (!this.$route.query.id) {
        this.getInitData();
      }
    },
    selectAsl(item, key, type) {
      this.selectedParam = item;
      this.selectedKey = key;
      this.selectedType = type;
      this.showAslDialog = true;
    },
    onConfirmAsl(data) {
      if(this.selectedType === "BASE") {
        this.$set(this.recordForm, "aslId", data.rmcProteinAslId);
        this.$set(this.recordForm, "aslName", data.aslName);
      } else if (this.selectedType === "LIST") {
        this.$set(this.selectedParam, "paramValue", data.aslName);
      } else {
        this.$set(this.selectedParam, this.selectedKey, data.aslName);
      }
      this.showAslDialog = false;
    },
    // 判断是否标准值, 不满足则标红显示
    checkStandardValue(data, value, type) {
      if (value && value != null && value != undefined && value != "") {
        if (data.standardType === "SINGLE") {    // 单值校验偏移
          if (data.standard && Number(data.standard) != Number(value)) {
            this.$set(data, "factorAbnormal", true);
            return true;
          }
        } else if (data.standardType === "RANGE") {    // 范围校验偏移 按2倍算
          console.log("------------------------")
          console.log(data)
          if (data.standard) {
            let rangeList = data.standard.split("-");
            let min = new Decimal(rangeList[0]);
            let max = new Decimal(rangeList[1]);
            // if (Number(value) < min / 2) {
            //   this.$set(data, "factorAbnormal", true);
            //   return true;
            // }
            // if (Number(value) > max * 2) {
            //   this.$set(data, "factorAbnormal", true);
            //   return true;
            // }
            let minValue = 0;
            let maxValue = 0;
            if(data.toleranceType === "PERCENTAGE") {
              let minRate = new Decimal(1).minus(new Decimal(data.tolerance/100));
              let maxRate = new Decimal(1).plus(new Decimal(data.tolerance/100));
              minValue = min.times(minRate).toFixed(4);
              maxValue = max.times(maxRate).toFixed(4);
            }
            if(data.toleranceType === "FIXED") {
              minValue = (min.minus(new Decimal(data.tolerance))).toFixed(4);
              maxValue = (max.plus(new Decimal(data.tolerance))).toFixed(4);
            }
            if (Number(value) < minValue) {
              this.$set(data, "factorAbnormal", true);
              return true;
            }
            if (Number(value) > maxValue) {
              this.$set(data, "factorAbnormal", true);
              return true;
            }
          }
        } else {    // 操作符校验偏移
          if (data.standard) {
            if (data.standard.indexOf(">=") > -1) {
              let max = Number(data.standard.split(">=")[1]);
              if (Number(value) < max) {
                this.$set(data, "factorAbnormal", true);
                return true;
              }
            } else if (data.standard.indexOf("<=") > -1) {
              let min = Number(data.standard.split("<=")[1]);
              if (Number(value) > min) {
                this.$set(data, "factorAbnormal", true);
                return true;
              }
            } else if (data.standard.indexOf(">") > -1) {
              let max = Number(data.standard.split(">")[1]);
              if (Number(value) <= max) {
                this.$set(data, "factorAbnormal", true);
                return true;
              }
            } else if (data.standard.indexOf("<") > -1) {
              let min = Number(data.standard.split("<")[1]);
              if (Number(value) >= min) {
                this.$set(data, "factorAbnormal", true);
                return true;
              }
            }
          }
        }
      }
      return false;
    },
    // 根据param的LineBreak分组表单参数
    groupedParams(params, factor) {
      console.log('factor :', factor);
      console.log('params :', params);
      let currentRow = [];
      let rows = [];
      (params || []).forEach(param => {
        if(param.dataType === "DICT") {
          param.dictTable = param.selectorType.split(":")[0];
          param.dictField = param.selectorType.split(":")[1];
        }
        if (param.lineBreak && currentRow.length > 0) {
          rows.push(currentRow)
          currentRow = []
        }
        currentRow.push(param)
      })
      if (currentRow.length > 0) {
        rows.push(currentRow)
      }
      console.log('rows :', rows);
      return rows
    },
    // 分组参数的表头,返回分组后的列
    groupedColumns(factor) {
      const groups = [];
      let currentGroup = null;
      for (const column of factor.params) {
        if(column.dataType === "DICT") {
          column.dictTable = column.selectorType.split(":")[0];
          column.dictField = column.selectorType.split(":")[1];
        }
        if (!column.category) {
          groups.push({
            category: null,
            columns: [column]
          });
          currentGroup = null;
        }
        else {
          if (!currentGroup || currentGroup.category !== column.category) {
            currentGroup = {
              category: column.category,
              columns: [column]
            };
            groups.push(currentGroup);
          } else {
            currentGroup.columns.push(column);
          }
        }
      }
      console.log(groups)
      return groups;
    },
    // 检查是否有空category的列
    hasEmptyCategory(factor) {
      return factor.params.some(column => !column.category);
    },
    // 限制输入框可输入内容,只能输入数字
    handleInput(row, field, type) {
      if (type === "LIST") {
        const value = row[field].paramValue;
        let formattedValue = value.replace(/[^\d.]/g, '');
        const decimalParts = formattedValue.split('.');
        if (decimalParts.length > 2) {
          formattedValue = `${decimalParts[0]}.${decimalParts.slice(1).join('')}`;
        }
        this.$set(row[field], "paramValue", formattedValue);
      } else {
        const value = row[field];
        let formattedValue = value.replace(/[^\d.]/g, '');
        const decimalParts = formattedValue.split('.');
        if (decimalParts.length > 2) {
          formattedValue = `${decimalParts[0]}.${decimalParts.slice(1).join('')}`;
        }
        this.$set(row, field, formattedValue);

        if(type === "SINGLE") {
          this.handleProcessVisible(row, field, type);
        }
      }
    },
    handleProcessVisible(row, field, type) {
      // if(formattedValue == 0 && formattedValue !== "") {
      //   Object.keys(row).forEach(k => {
      //     let data = row[k];
      //     if (data.processList && data.processList.length > 0) {
      //       data.processList.forEach(item => {
      //         let process = this.recordForm.processes.find(process => process.processCode === item.processCode);
      //         if(process) {
      //           this.$set(process, "display", "none");
      //         }
      //       })
      //     }
      //   })
      // } else {
      //   this.recordForm.processes.forEach(process => {
      //     this.$set(process, "display", null);
      //   })
      // }
      let value = row[field];
      if(value == 0 && value !== "") {
        if (row.processList && row.processList.length > 0) {
          row.processList.forEach(item => {
            let process = this.recordForm.processes.find(process => process.processCode === item.processCode);
            if(process) {
              this.$set(process, "display", "none");
            }
          })
        }
      } else {
        if (row.processList && row.processList.length > 0) {
          row.processList.forEach(item => {
            let process = this.recordForm.processes.find(process => process.processCode === item.processCode);
            if(process) {
              this.$set(process, "display", "null");
            }
          })
        }
      }
    },
    // 特定参数指标不达标则关联的参数需要设为必填（目前参数为固定写死）
    calcSpecialParamRequired(param, paramValue, score) {
      if (param.paramCode === "PARAM_0218") {      // 外观
        this.recordForm.processes.forEach(process => {
          if (process.factors && process.factors.length > 0) {
            process.factors.forEach(factor => {
              if (factor.params && factor.params.length > 0) {
                factor.params.forEach(param => {
                  if (param.paramCode === "PARAM_0219") {
                    if (Number(paramValue) < Number(score)) {
                      this.$set(param, "required", true)
                    } else {
                      this.$set(param, "required", false)
                    }
                  }
                })
              }
            })
          }
        })
      }
      if (param.paramCode === "PARAM_0220") {     // 质地
        this.recordForm.processes.forEach(process => {
          if (process.factors && process.factors.length > 0) {
            process.factors.forEach(factor => {
              if (factor.params && factor.params.length > 0) {
                factor.params.forEach(param => {
                  if (param.paramCode === "PARAM_0221") {
                    if (Number(paramValue) < Number(score)) {
                      this.$set(param, "required", true)
                    } else {
                      this.$set(param, "required", false)
                    }
                  }
                })
              }
            })
          }
        })
      }
      if (param.paramCode === "PARAM_0222") {      // 风味
        this.recordForm.processes.forEach(process => {
          if (process.factors && process.factors.length > 0) {
            process.factors.forEach(factor => {
              if (factor.params && factor.params.length > 0) {
                factor.params.forEach(param => {
                  if (param.paramCode === "PARAM_0223") {
                    if (Number(paramValue) < Number(score)) {
                      this.$set(param, "required", true)
                    } else {
                      this.$set(param, "required", false)
                    }
                  }
                })
              }
            })
          }
        })
      }
    },
    calcSpecialParamRequiredList(dataMap, field, score) {
      let keys = Object.keys(dataMap);
      Object.keys(dataMap).forEach(key => {
        let param = dataMap[key];
        if (param.paramCode === 'PARAM_0218') {    // 外观
          let paramValue = dataMap[key].paramValue;
          let targetIndex = keys.findIndex(key => dataMap[key].paramCode === 'PARAM_0218');
          const nextKey = keys[targetIndex + 1];
          const nextParam = dataMap[nextKey];    // 外观缺陷
          if(Number(paramValue) < Number(score)) {
            this.$set(nextParam, "required", true);
          } else {
            this.$set(nextParam, "required", false);
          }
        }
        if (param.paramCode === 'PARAM_0220') {    // 质地
          let paramValue = dataMap[key].paramValue;
          let targetIndex = keys.findIndex(key => dataMap[key].paramCode === 'PARAM_0220');
          const nextKey = keys[targetIndex + 1];
          const nextParam = dataMap[nextKey];     // 质地缺陷
          if(Number(paramValue) < Number(score)) {
            this.$set(nextParam, "required", true);
          } else {
            this.$set(nextParam, "required", false);
          }
        }
        if (param.paramCode === 'PARAM_0222') {    // 风味
          let paramValue = dataMap[key].paramValue;
          let targetIndex = keys.findIndex(key => dataMap[key].paramCode === 'PARAM_0222');
          const nextKey = keys[targetIndex + 1];
          const nextParam = dataMap[nextKey];     // 风味缺陷
          if(Number(paramValue) < Number(score)) {
            this.$set(nextParam, "required", true);
          } else {
            this.$set(nextParam, "required", false);
          }
        }
      });
    },
    // 计算表头内容宽度(名称+标准值+单位)
    calcMinWidth(str1, str2, str3) {
      let label = str1 + str2 + str3;
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = '12px "PingFang SC", "Helvetica Neue", Helvetica, "microsoft yahei", arial, STHeiTi, sans-serif';
      let textWidth = ctx.measureText(label || '').width;
      let finalWidth = Math.ceil(textWidth) + 40;
      return finalWidth > 140 ? finalWidth : 140
    },
    // 返回
    goBack() {
      this.$router.push({
        path: "/process-monitoring/record"
      })
    }
  }
}

</script>

<style scoped>
:deep(.process__record__card .el-card__header) {
  padding: 10px !important;
}

:deep(.process__record__card.factor__card .el-card__header) {
  background: linear-gradient(to right, #f5f5dc, #fffa77);
}

:deep(.process__record__card .el-card__header .title) {
  display: flex;
  align-items: center;
}

:deep(.factor__form .el-form-item.el-form-item--small) {
  margin-bottom: 0 !important;
}

:deep(.factor__form .el-form-item.el-form-item--small.is-error) {
  margin-bottom: 18px !important;
}

:deep(.el-row) {
  display: flex;
  flex-wrap: wrap;
}

/*:deep(.el-form-item__label) {
    line-height: 33px !important;
  }

  :deep(.single__ .el-form-item__label) {
    float: none !important;
  }*/

.searchBox_top {
  margin-top: 10px;
  margin-bottom: 10px;
  display: flex;
  justify-content: flex-end;
}

:deep(.process__body .el-card__body) {
  padding: 0 !important;
}

.circle__default {
  width: 25px;
  height: 25px;
  line-height: 25px;
  broder: 1px solid;
  background: #f4f4f5;
  text-align: center;
  border-radius: 15px;
  font-weight: bold;
  color: #666666;
}

.circle__small {
  width: 16px;
  height: 16px;
  line-height: 16px;
  background: #f0f2f5;
  text-align: center;
  border-radius: 8px;
  font-size: 10px;
  color: #909399;
}

.process__item {
  padding: 8px 15px 8px 15px;
  margin: 2px 8px;
  border-radius: 5px;
}

.process__item:hover {
  border: 1px solid #f8ab01;
  background: #ffffe0;
  cursor: pointer;
}

.process__item.selected {
  border: 2px solid #f8ab01;
  background-color: #fffacd;
  box-shadow: 0 6px 14px rgba(0, 0, 0, 0.1);
  font-weight: bold;
  color: #f8ab01;
}

.process__item.selected .circle__default {
  background: #f8ab01;
  color: #ffffff;
}

:deep(.factor__card .el-card__header) {
  background: #f8f9fa;
}

:deep(.invalid__ .el-input__inner) {
  background-color: #ffcccc;
}

.param__tip {
  position: relative;
  margin-left: 2px;
  color: #f8ab01;
  font-size: 10px;
  cursor: pointer;
  z-index: 999;
}
</style>